import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of, catchError } from 'rxjs';
import { ManualService } from '../services/manual-service';

export const manualResolver: ResolveFn<any> = (route, state) => {
  const manualService = inject(ManualService);
  const id = route.paramMap.get('id') || route.paramMap.get('serialNumber') || '';
  if (!id) {
    return of(null);
  }
  return manualService.getManualById(id).pipe(
    catchError(() => of(null))
  );
};
